import { Controller } from '@hotwired/stimulus'
import { stimulus } from '~/init'

class FileInputController extends Controller {
  static targets = ['input', 'label', 'text']
  static values = {
    placeholder: { type: String, default: 'Файл не выбран' },
    buttonLabel: { type: String, default: 'Выбрать файл' }
  }

  connect () {
    this.textTarget.textContent = this.placeholderValue
  }

  trigger () {
    this.inputTarget.click()
  }

  change () {
    const files = this.inputTarget.files
    if (files.length > 0) {
      this.textTarget.textContent = files[0].name
    } else {
      this.textTarget.textContent = this.placeholderValue
    }
  }
}

stimulus.register('file-input', FileInputController)
